import React, { useEffect, useCallback, useState } from "react";
import styled from "styled-components";
import ToolsBar from "./toolsBar";
import PaginationNav from "./paginationNav";
import FormTitle from "components/formTitle";
import logger from "utils/logger";
import GridTable from "./gridTable";
import data from "services/data";
import Button from "./button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import notifier from "utils/notifier";

const StyledMiniPluginVer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
`;

const StyledTitle = styled.div`
  flex: 1;
  font-size: ${({ theme, size }) => (size ? size : theme.fontSize.slarge)};
  font-weight: 600;
  color: ${({ theme }) => theme.fontColor};
  text-align: center;
`;

const StyledIcon = styled(FontAwesomeIcon)``;

const tablePageSize = 6;

const MiniPluginVer = ({
  pluginAppId = "",
  pluginName = "",
  onBack,
  onChooseDep,
}) => {
  const [keyword, setKeyword] = useState("");
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const getPluginVerList = useCallback(
    async (appId, pageSize, currentPage) => {
      if (!appId) return;
      try {
        const { totalCount, pluginVerList } =
          await data.getPluginVerListByAppId({
            pluginAppId: appId,
            pageSize,
            currentPage,
            keyword,
          });
        setList(pluginVerList);
        setTotal(totalCount);
      } catch (e) {
        notifier.error(e.message);
      }
    },
    [keyword]
  );

  const handleSearch = useCallback(() => {
    getPluginVerList(pluginAppId, tablePageSize, 1);
    setCurrentPage(1);
  }, [getPluginVerList, pluginAppId]);

  const handleCurrentPageChange = useCallback(
    (pageNum) => {
      setCurrentPage(pageNum);
      getPluginVerList(pluginAppId, tablePageSize, pageNum);
    },
    [getPluginVerList, pluginAppId]
  );

  useEffect(() => {
    getPluginVerList(pluginAppId, tablePageSize, 1);
  }, [pluginAppId]);

  if (!pluginAppId) return null;

  return (
    <StyledMiniPluginVer>
      <StyledHeader>
        <Button title="返回" messageArea={false} onClick={onBack}>
          <StyledIcon icon={faAngleLeft} />
          {" Back"}
        </Button>
        <StyledTitle size="15px">{pluginName}</StyledTitle>
      </StyledHeader>

      <ToolsBar
        mode="mini"
        search={{
          value: keyword,
          setValue: setKeyword,
          onSearch: handleSearch,
          placeholder: "版本号...",
        }}
      />
      <GridTable
        mode="mini"
        heads={["版本ID", "版本号"]}
        paths={["id", "version"]}
        items={list}
        showTools={true}
        auth={true}
        tools={[
          {
            type: "add",
            title: "选中",
            onClick: (data) => {
              logger.log("点击了添加版本依赖 当前点击的版本依赖：", data);
              onChooseDep && onChooseDep(data);
            },
          },
        ]}
      />
      <PaginationNav
        mode="mini"
        total={total}
        pageSize={tablePageSize}
        currentPage={currentPage}
        onCurrentPageChange={handleCurrentPageChange}
      />
    </StyledMiniPluginVer>
  );
};

export default MiniPluginVer;
